import i18n from 'i18next';
import moment from 'moment';
import translations from '../locales';
import {TYPE_ISSUES, TYPE_QUALITY_ISSUES} from '../constants/issue-types';

const i18nInstance = i18n.createInstance();
export default i18nInstance;

const setLanguage = language => {
  // Override "Field issues" translation with "Issues"
  Object.keys(translations).forEach(translationKey => {
    translations[translationKey].translation.issueType[TYPE_QUALITY_ISSUES] =
      translations[translationKey].translation.issueType[TYPE_ISSUES];
  });

  i18nInstance.init(
    {
      lng: language,
      fallbackLng: 'en',
      resources: translations
    },
    (/*_err, _t*/) => {}
  );
};

const setLocale = locale => {
  if (locale === 'zh-Hans') {
    locale = 'zh-CN';
  }
  moment.locale(locale);
};

export {setLanguage, setLocale};
